import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsInstructablesComponent } from './simple-icons-instructables.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsInstructablesComponent ],
    exports:      [ SimpleIconsInstructablesComponent ],
    bootstrap:    []
})
export class SimpleIconsInstructablesModule {}
